function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.26974 22.3499C6.32894 29.3806 15.3191 31.7896 22.3499 27.7304C29.3806 23.6712 31.7895 14.681 27.7303 7.65022C23.6711 0.619471 14.6809 -1.78944 7.6502 2.26976C0.619446 6.32897 -1.78947 15.3192 2.26974 22.3499ZM5.23031 20.6417C8.34551 26.0374 15.245 27.8861 20.6406 24.7709C26.0363 21.6557 27.885 14.7562 24.7698 9.36054C21.6546 3.96485 14.7552 2.11615 9.3595 5.23135C3.9638 8.34655 2.1151 15.246 5.23031 20.6417Z",
  fill: "url(#paint0_angular_803_17479)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_angular_803_17479",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.5975 14.6583) rotate(164.932) scale(18.4094)"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})));
var SvgTeligentiploader = function SvgTeligentiploader(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeligentiploader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/teligentiploader.8f09c417.svg";
export { ForwardRef as ReactComponent };